import flatten from 'flat'
import { ModelTranslations } from '../components/langContext/languagesModel'

const target = {
	app: {
		devise: 'euros',
		details: 'Learn more',
		back: 'Back'
	},
	errors: {
		dqe: {
			format_email: 'Incorrect email format',
			creation_non_authorized: 'Account creation not allowed for this email',
			temporary_email: 'Please do not use a temporary email address for your YouFirst account',
			full_inbox: 'The specified email cannot receive new messages',
			email_not_found: 'The specified email wasn\'t found for this domain',
			invalid_phone: 'The phone number is not valid'
		}
	},
	fabField: {
		choixResidence: {
			ouiPreference: 'Yes, preferably',
			ouiAbsolument: 'Yes, absolutely',
			non: 'No'
		},
		nombrePieces: {
			studio: 'Studio',
			piece2: '1-bedroom apartment',
			piece3: '2-bedroom apartment',
			piece4: '3-bedroom apartment',
			piece5: '4-bedroom apartment',
			piece6: '5-bedroom apartment or more'
		},
		nombreChambres: {
			chambre1: '1 bedroom',
			chambre2: '2 bedrooms',
			chambre3: '3 bedrooms',
			chambre4: '4 bedrooms or more'
		},
		espaceExterieur: {
			balcon: 'Balcony',
			jardin: 'Garden',
			terrasse: 'Terrace'
		},
		typeVehicule: {
			voiture: 'Car',
			moto: 'Motorbike'
		},
		isStudent: {
			oui: 'YES',
			non: 'NO',
		},
		isBoursier: {
			oui: 'YES',
			non: 'NO',
		}
	},
	menu: {
		dashboard: 'Dashboard',
		news: 'News',
		services: 'Services',
		contracts: 'Your account',
		requests: 'Your requests',
		questions: 'Questions?',
		profile: 'Your profile',
		dossier: 'Your application',
		logout: 'Log out',
		accessibility: {
			title: {
				enableVisualHandicap: 'View the e-accessible version',
				disableVisualHandicap: 'Exit the e-accessible version'
			}
		}
	},
	dashboard: {
		welcome: 'Welcome to\nyour Customer Area',
		documents: 'Your documents',
		questions: 'Frequently asked questions',
		request: 'Submit a request',
		repair: 'Tenant repair guide',
		contracts: {
			title: 'Your account',
			link: 'All your contracts',
			emptyContractsText: 'You don\'t have any active contracts',
			emptyContractsLink: 'View your closed contracts',
			type: {
				apartment: 'Apartment',
				garage: 'Parking'
			},
			lease: 'Lease no. {lease} - ',
			balance: 'Balance',
			onGoingRequests: 'Your ongoing requests',
			onGoingText: 'Administrative request {date}',
			recentsDocuments: 'Your recent documents',
			details: 'View details'
		},
		news: {
			emptyState: 'No news to display for your residence'
		}
	},
	requests: {
		title: 'Your ongoing requests',
		titleTreated: 'Your closed requests',
		emptyRequests: 'No ongoing request',
		emptyRequestsSubText: 'All your requests have been processed',
		link: 'Show your closed requests',
		createdAt: 'Created on {date}',
		updatedAt: 'Updated on {date}',
		closedAt: 'Closed on {date}',
		canceledAt: 'Cancelled on {date}',
		responseNotFound: 'Didn\'t find an answer in our frequently asked questions?',
		anotherRequest: 'Would you like to submit a new request?',
		frequentQuestions: 'Frequently asked questions',
		havingQuestions: 'Do you have a question? {br} Find your answer quickly by browsing our frequently asked questions by topic.',
		reparations: 'Your tenant repair guide',
		welcome: 'Your welcome booklet',
		download: 'Download',
		visit: 'View',
		otherCategory: 'Other',
		makeRequest: {
			title: 'Submit a request',
			more: 'Could you tell us more?',
			subHeader: {
				technical: 'Technical request',
				administrative: 'Administrative request'
			},
			step0: {
				title: 'What type of request is this?'
			},
			step1: {
				title: 'What is the subject of your request?',
				technical: 'Technical',
				administrative: 'Administrative'
			},
			guideReparations: {
				text1: 'Before creating a technical request, we invite you to consult <span>the tenant repair guide.</span> This will allow you to quickly check whether the repair is your responsibility or YouFirst\'s. If after verification the repair is indeed the responsibility of YouFirst Residence in the private areas, please complete this form.',
				text2: 'A clogged sink? A broken window? A faulty switch? You will be guided to better understand what is your responsibility and what is the responsibility of YouFirst Residence in the private areas.',
				link: 'View the tenant repair guide'
			},
			step2: {
				title: 'What is the subject of your request?',
				titlePrivate: 'Select the item concerned by your request',
				private: 'Private areas',
				common: 'Common areas',
				sinisters: 'Claims',
				bill: 'Payments and Invoicing',
				neighbor: 'Life in the residence and neighborhood',
				contract: 'Contract life',
				deposit: 'Lease termination',
				debit: 'Direct debit',
				assurance: 'Home insurance certificate'
			},
			step3: {
				title: 'Which property is concerned?',
				titleDeposit: 'Which contracts are concerned?',
				heater: 'Heating',
				electricity: 'Electricity',
				ventilation: 'Ventilation',
				joinery: 'Carpentry, locksmithing',
				plumbing: 'Plumbing',
				disinfection: 'Pest control, rodent control, disinfection',
				authorization: 'Authorization / work request',
				hotWater: 'Hot water',
				water: 'Water',
				gaz: 'Gaz',
				waterInfiltration: 'Leak / infiltration',
				miscellaneous: 'Miscellaneous',
				shutter: 'Roller shutters',
				others: 'Others',
				elevator: 'Elevator',
				security: 'Safety equipment',
				door: 'Access (Lobby, parking gate, intercom)',
				light: 'Lighting',
				maintenance: 'Common areas maintenance',
				technicalLocal: 'Technical room (Garbage chute, bike room, etc.)',
				letters: 'Mailbox',
				optic: 'Fiber optic',
				renovation: 'Renovation / Construction',
				electrical: 'Charging station',
				waterDamages: 'Water damage',
				fire: 'Fire',
				brokenGlass: 'Glass breakage',
				rent: 'Rent, revisions...',
				rentalCharge: 'Rental charges',
				debit: 'Direct debit',
				paymentNotCashed: 'Uncollected payment',
				contestBill: 'Billing dispute',
				parking: 'Illegal parking / abandoned vehicle',
				clutter: 'Clutter in common areas',
				trade: 'Related to a business',
				smell: 'Odors / dirt',
				sound: 'Disturbance of enjoyment',
				requestParking: 'Parking space request / change',
				requestHome: 'Business domiciliation request',
				occupantsModification: 'Change of occupants',
				transferDocuments: 'Document submission',
				renewLease: 'Lease renewal',
				key: 'Key or access badge',
				changeFlat: 'Change apartment',
				deliveryBox: 'Smart parcel locker',
				sharedLib: 'Shared library',
				plumbingCommon: 'Plumbing',
				deposit: 'Lease termination',
				assurance: 'Home insurance certificate',
				link: 'Click here to download the tenant repair guide',
				entree: 'Front door',
				serruresbarillets: 'Locks and cylinders',
				clesbadges: 'Keys and access badges',
				electriciteeclairage: 'Electricity and lighting',
				detecteurfumee: 'Smoke detector',
				fenetresencadrements: 'Windows and frames',
				voletsbasse: 'Roller shutters, blinds, and jalousies – lower section (handle)',
				voletshaute: 'Roller shutters, blinds, and jalousies – upper section (mechanism)',
				vitrage: 'Glazing',
				convecteursradiateurs: 'Electric heaters and radiators',
				mursinterieurs: 'Interior walls, partitions, and ceilings',
				parquets: 'Wood flooring',
				moquetterevetements: 'Carpet and other floor coverings',
				aerationventilation: 'aeration and ventilation',
				vmc: 'Controlled mechanical ventilation (CMV)',
				arriveegaz: 'Gas supply',
				flexiblegaz: 'Gas hose',
				flexiblegrillesiphon: 'Hose, grid, and trap (sink, washbasin, shower)',
				colonneeaux: 'Wastewater column',
				canalisationseauusees: 'Water and wastewater pipes',
				abattantswc: 'Toilet seat covers',
				canalisationeau: 'Water pipes',
				douchetteflexibledouche: 'Showerhead and flexible hose',
				carrelagefaience: 'Tiles and wall tiling',
				robinetterie: 'Taps and fittings',
				chasseeau: 'Flush mechanism',
				evierslavabosbaignoiressanitaires: 'Sinks, washbasins, bathtubs, and sanitary ware',
				chaudieremuraleballonelectrique: 'Wall-mounted boiler and electric water heater',
				cave: 'Cellar',
				boxstationnement: 'Parking space',
				terrassebalcon: 'Terrace & balcony',
				divers: 'Miscellaneous',
				electromenager: 'Appliances',
				equipementsconfort: 'Furniture and equipment',
				private: {
					boutons: {
						locatif: 'Information request',
						bailleur: 'Maintenance request',
					},
					legende: {
						bailleur: 'AT YOUFIRST’S EXPENSE',
						locatif: 'AT YOUR EXPENSE',
					},
					description: {
						entree: 'If the door is warped, damaged due to wear, or has a structural defect, replacement is YouFirst’s responsibility.',
						serruresbarillets: 'If you lose your keys or break the lock while using it, you must replace the cylinder.',
						clesbadges: 'In case of loss or damage, you must replace your keys or access badges.',
						electriciteeclairage: 'If a light bulb burns out or a fuse blows, you must replace them.',
						detecteurfumee: 'If the smoke detector beeps or stops working, you must dust the device, replace the batteries, or replace the detector if necessary.',
						fenetresencadrements: 'If the frame is damaged by wear or the seals are defective, YouFirst must intervene.',
						voletsbasse: 'If the handle is damaged, you must repair or replace it.',
						voletshaute: 'If the upper mechanism (roller, motor) is faulty, it is YouFirst’s responsibility to repair it.',
						vitrage: 'If a windowpane is broken due to impact, you must replace it.',
						convecteursradiateurs: 'If a heater is dirty or not working properly, you must clean it and check its proper use.',
						mursinterieurs: 'If you make holes or stains on the walls, you must fill and clean them.',
						parquets: 'If the floor is scratched or stained, you must clean or repair it.',
						moquetterevetements: 'If stains appear, you must clean or replace the covering.',
						aerationventilation: 'If the air does not circulate properly, clean the vents and air grilles.',
						vmc: 'Dust the air vents, clean the filters, and check that air circulates properly.',
						arriveegaz: 'If the general installation has a defect or needs to be brought up to standard, YouFirst is responsible.',
						flexiblegaz: 'If the flexible hose installation no longer meets safety standards (structural wear, faulty installation), YouFirst is responsible.',
						flexiblegrillesiphon: 'If limescale deposits or blockages appear, you must clean and unclog them.',
						colonneeaux: 'If a leak comes from a built-in pipe or a building column, YouFirst must repair it.',
						canalisationseauusees: 'If a leak occurs or a structural defect appears, YouFirst is responsible for the repair and remains in charge of the main pipes.',
						abattantswc: 'If the toilet seat is broken or worn, you must replace it.',
						canalisationeau: 'If a siphon is blocked, you must unclog it.',
						douchetteflexibledouche: 'If the shower hose is punctured or scaled, you must replace it.',
						carrelagefaience: 'If you break a tile, you must replace it.',
						robinetterie: 'If a tap leaks or drips, you must replace the washers or cartridges.',
						chasseeau: 'If the flush leaks, you must replace the washers or float.',
						evierslavabosbaignoiressanitaires: 'If parts are broken or damaged, descale or replace them.',
						chaudieremuraleballonelectrique: 'In case of a breakdown due to wear or a structural defect, replacement is YouFirst’s responsibility.',
						cave: 'If you leave waste or clutter, you must clean it.',
						boxstationnement: 'If you damage the lock or door while handling it, you must repair it.',
						terrassebalcon: 'If the balcony is dirty or cluttered, you must clean it.',
						divers: 'Can\'t find your situation in the categories above? Click the button below and tell us more about your issue. We will get back to you as soon as possible.',
						electromenager: 'If an appliance breaks down due to misuse, you must replace it.',
						equipementsconfort: 'If you break, lose, or damage any item(furniture, tableware, decoration), you must replace it.',
					},
				}
			},
			step4: {
				title: 'Please specify your request',
				titlePlaceholder: 'Enter the subject of your request',
				messagePlaceholder: 'Enter your message',
				messageOptionnelPlaceholder: 'Enter your message (optional)',
				attachmentLabel: 'Add an attachment',
				submit: 'Send your request',
				chooseOption: 'To allow us to schedule an intervention, if necessary, we invite you to select one of the following three options:',
				keyExampleOption: 'I leave a copy of my keys at the reception desk of my YouFirst Manager',
				datesOption: 'I select three time slots',
				advisorOption: 'I prefer to be contacted by my YouFirst Manager',
				choice1: 'Choice 1',
				choice2: 'Choice 2',
				choice3: 'Choice 3',
				dateText: 'Date',
				timeSlotText: 'Time slot',
				assurance: {
					dateDebut: {
						label: 'Insurance start date',
						sublabel: 'Enter here the start date of your new insurance certificate',
						echeance: 'Insurance start date: '
					},
					dateFin: {
						label: 'Insurance end date',
						sublabel: 'Enter here the end date of your new insurance certificate',
						echeance: 'Insurance end date: '
					},
					information: 'Please provide us with your insurance certificate.'
				},
				deposit: {
					info_resi: {
						title: 'At YouFirst, we want to simplify your daily life, even when you say goodbye. To notify us of your departure, we offer you <strong>a quick and 100% digital process</strong>, including the legal steps.',
						first: 'You submit your lease termination request in your Customer Area:',
						second: 'You fill in the form below with the information related to your termination request.',
						third: 'You sign this request electronically via the secure YouSign signature platform.',
						fourth: 'That’s it: you have given notice while complying with all formalities. <strong>Your one-month minimum notice period (or 3 months for a civil lease) begins at signature. No tedious registered letter with acknowledgment of receipt</strong>: you can focus on packing your boxes.',
						five: 'After signing your termination request, please wait a few minutes before seeing your request appear in your personal space.',
						formalize: 'We formalize your lease termination request with the information provided.'
					},
					info_campus: {
						title: 'At YouFirst, we want to simplify your daily life, even when you say goodbye. To notify us of your departure, we offer you <strong>a quick and 100% digital process</strong>, including the legal steps.',
						first: 'You submit your lease termination request in your Customer Area:',
						second: 'You fill in the form below with the information related to your termination request.',
						third: 'You sign this request electronically via the secure YouSign signature platform.',
						fourth: 'That’s it: you have given notice while complying with all formalities. <strong>Your one-month notice period begins at signature. No tedious registered letter with acknowledgment of receipt</strong>: you can focus on packing your boxes.',
						five: 'After signing your termination request, please wait a few minutes before seeing your request appear in your personal space.',
						formalize: 'We formalize your lease termination request with the information provided.'
					},
					date: {
						info: 'As a reminder, the notice period is one month. If you choose a departure date before the end of this period, the rent remains due until its expiration.',
						label: 'Desired departure date'
					},
					phone: 'Mobile phone number',
					preCheckLocation: 'Your preferences for the pre-check-out inspection appointment',
					checkLocation: 'Your preferences for the check-out inspection appointment (subject to YouFirst team availability)',
					checkLocationInfo: 'Key handover takes place on the day of the check-out inspection.',
					datesOption: 'I select three time slots',
					advisorOption: 'I prefer to be contacted by my YouFirst Manager',
					leaveReason: {
						label: 'Reason for departure',
						campus: {
							changeSchool: 'Change of school / university',
							changeStatus: 'Change of status / end of studies',
							intership: 'Internship / Going abroad',
							otherType: 'Wish for another type of apartment',
							unsatisfied: 'Dissatisfaction related to YouFirst Campus',
							foundCheaper: 'Value for money, found cheaper housing',
							surrounding: 'Environment: Noise pollution / Insecurity',
							other: 'Other (please specify)'
						},
						both: {
							family: 'Change in family situation',
							professional: 'Change in professional situation',
							otherType: 'Wish for another type of apartment / parking',
							neighbour: 'Neighborhood problem',
							acquisition: 'Purchase',
							budget: 'Financial reason',
							residence: 'Dissatisfaction related to the residence / parking',
							apartment: 'Dissatisfaction related to the apartment / parking',
							other: 'Other'
						},
						apartment: {
							family: 'Change in family situation',
							professional: 'Change in professional situation',
							otherType: 'Wish for another type of apartment',
							neighbour: 'Neighborhood problem',
							acquisition: 'Purchase',
							budget: 'Financial reason',
							residence: 'Dissatisfaction related to the residence',
							apartment: 'Dissatisfaction related to the apartment',
							other: 'Other'
						},
						parking: {
							vehicle: 'Change of vehicle',
							otherType: 'Wish for another type of parking',
							acquisition: 'Purchase',
							principalChanged: 'Change of main residence',
							professional: 'Professional reason',
							parking: 'Dissatisfaction related to parking',
							residence: 'Dissatisfaction related to the residence',
							other: 'Other'
						}
					},
					comment: 'Comment',
					isAlone: 'I am the only one leaving the apartment, and this notice is therefore addressed in my name only',
					hasCopreneurs: 'For this request, I commit on behalf of all leaseholders, and this notice is therefore addressed in the name and on behalf of all leaseholders, Individual or collective notice submission',
					isStandalone: 'Individual or collective notice submission',
					rib: {
						info: 'In order to process the refund of your security deposit, if the check-out inspection matches the check-in inspection, please attach your bank account details (RIB).',
						attachment: 'Add a RIB',
						allow: {
							label: 'I authorize YouFirst Campus to refund my security deposit to the account holder mentioned in the attached RIB',
							error: 'You must authorize YouFirst Campus to proceed with the refund based on the provided RIB'
						}
					},
					submit: 'Continue your request',
					erreurs: {
						residence: 'An error has occurred, please contact your Property Manager',
						campus: 'An error has occurred, please contact your YouFirst Manager'
					}
				}
			},
			step5: {
				iframeTitle: 'Lease termination signature',
				title: 'Your request has been successfully sent.',
				text: 'We will contact you as soon as possible.',
				textRdv : 'Make sure to schedule your move-out inspection and key handover with your YouFirst Manager now.',
				finish: 'Finish',
				rdv: 'Schedule an appoitment',
				remakeRequest: 'Submit a new request'
			},
			previousStep: 'Previous step',
			nextStep: 'Next step'
		},
		response: {
			title: 'Send a response',
			submit: 'Send your response'
		},
		detail: {
			back: 'All your requests',
			btnAnswer: 'Write your message',
			title: 'Your request',
			sentAt: 'Sent on {date}',
			nbAnswers: '{nbAnswers, plural, one {answer} other {answers}}',
			myAnnotations: 'You attached {nbAnnotations} file(s)',
			responseService: 'Your YouFirst team',
			sentAMessage: 'You sent a message',
			errorPreviewAnnotation: 'The attachment does not exist',
			keyOptionChosen: 'You chose to leave a copy of your keys at the reception desk of your YouFirst Manager',
			advisorOptionChosen: 'You chose to be contacted by your YouFirst Manager',
			datesOptionChosen: 'You selected the following availability slots:'
		},
		weekDays: {
			Lundi: 'Monday',
			Mardi: 'Tuesday',
			Mercredi: 'Wednesday',
			Jeudi: 'Thursday',
			Vendredi: 'Friday'
		},
		timeSlots: {
			Matin: 'Morning',
			'Après-midi': 'Afternoon'
		}
	},
	faq: {
		faq_title: 'How can we help you?',
		placeholder: 'Enter your keywords (e.g., rent receipt, lease, claim)',
		smallPlaceholder: 'Enter your keywords',
		category: 'Or choose a FAQ category',
		lease: 'Your Lease',
		appartment: 'Your Apartment',
		services: 'Your Services',
		customer: 'Your Customer Area',
		no_answer: 'Didn\'t find any answers?',
		ask: 'Ask us your question directly',
		request: 'Submit a request',
		contact: 'Contact us',
		searchEmpty: 'No question matches your search'
	},
	you_first_manager: {
		listenDefault: 'We are here to listen',
		manager: 'Your YouFirst Manager ',
		managers: 'Your YouFirst Managers',
		sendMsg: 'Send a message',
		availabilityManager: 'Emergency numbers to use outside reception desk',
		technical: 'Technical emergency',
		elevator: 'Elevator technician',
		heating: 'Heating engineer',
		parking: 'Parking doors',
		emergency: 'Emergency number',
		defaultYfm: 'Your YouFirst team'
	},
	news: {
		title: 'News',
		link: 'All news',
		breadcrumb: {
			actualite_exploitation: 'Practical information',
			actualite_marketing: 'Life in your residence'
		},
		questions: {
			title: 'Do you have a question?',
			text: 'Find your answer quickly by browsing our frequently asked questions by topic.',
			button: 'View'
		},
		ariaLabel: 'Learn more about the news: {news}',
		seeAllNews: 'View all news',
		details: {
			error: 'The requested news wasn\'t found'
		}
	},
	topAlert: {
		ariaLabel: 'Learn more about the alert: {alert}',
		details: {
			error: 'The requested alert wasn\'t found'
		}
	},
	customAlert: {
		title: 'Direct debit',
		informations: 'Choose direct debit and simplify the management of your rental.',
		hideAlert: 'Hide alert',
		subscribe: 'Subscribe',
		assurance: {
			title: 'Important',
			deposit: 'Submit your certificate',
			finie: {
				informations: 'Your insurance certificate has expired. Please provide it to us as soon as possible.'
			},
			proche: {
				informations: 'Your insurance certificate is about to expire. Remember to send us your new certificate as soon as possible.',
			}
		}
	},
	contracts: {
		title: 'Your contracts',
		docsTab: 'Your documents',
		accountTab: 'Your account statement',
		document: {
			date: 'Date',
			name: 'Name',
			ddl: 'Download',
			emptyDocs: 'You don\'t have any documents matching your selection',
			selectAll: 'All',
			andBefore: 'and before',
			serverErrors: {
				noDocument: 'Error retrieving documents'
			}
		},
		account: {
			balance: 'Your balance',
			payBalance: 'Pay the balance',
			payBalanceTitle: 'Your account balance will be updated 24 hours after your payment',
			leftToPay: 'Remaining balance ',
			accountDetails: 'Your account statement',
			deadline: 'Due date',
			operation: 'Transaction label',
			amount: 'Amount',
			status: 'Status',
			onDay: 'to ',
			euro: ' €',
			emptyOp: 'No transactions to display',
			toPay: 'To be paid',
			paid: 'Paid',
			debitBalance: 'Overdrawn balance',
			payment: {
				title: 'Secure payment',
				all: {
					subtitle: 'Payment of your balance',
					description: 'You are about to pay the amount of: '
				},
				partial: {
					subtitle: 'Make your payment',
					description1: 'You are about to pay your invoice',
					description2: 'The full amount must be paid in a single payment.',
					amountNegative: 'The amount cannot be negative',
					amountZero: 'The amount cannot be zero',
					amountMax: 'The amount cannot exceed {amount}',
					amountString: 'The amount can only contain numbers',
					amountExact: 'The full invoice amount must be paid',
					btnPartial: 'Remaining balance: {amount}€',
					btnFull: 'To be paid: {amount}€'
				},
				finished: {
					success: {
						title: 'Your payment has been successfully processed.',
						description: 'Your balance will be updated within <strong>24 hours</strong>.<p>' +
							'Thank you for your trust.</p>' +
							'Your YouFirst team'
					},
					error: {
						title: 'Your payment could not be processed. You will not be charged.',
						description: {
							'00001': 'Please try again later with a different payment card or contact your Property Manager.',
							'001': 'Please try again later with a different payment card or contact your Property Manager.',
							'00003': 'Please try again later with a different payment card or contact your Property Manager.',
							'00004': 'Please try again later with a different payment card or contact your Property Manager.',
							'00006': 'Please contact your Property Manager.',
							'00008': 'Please try again later with a different payment card or contact your Property Manager.',
							'00009': 'Please contact your Property Manager.',
							'00010': 'Please try again later with a different payment card or contact your Property Manager.',
							'00011': 'Please try again later with a different payment card or contact your Property Manager.',
							'00016': 'Please contact your Property Manager.',
							'00021': 'It seems your card is invalid. Accepted cards are CB Visa and MasterCard. Please try again with a valid card.',
							'00029': 'Please try again later with a different payment card or contact your Property Manager.',
							'00030': 'The payment deadline has passed, please try again or contact your Property Manager.',
							'00033': 'Please try again later with a different payment card or contact your Property Manager.',
							'00040': 'Please try again later with a different payment card or contact your Property Manager.'
						}
					}
				},
				btn: 'Pay online'
			}
		}
	},
	profile: {
		title: 'Your profile',
		personalInfo: 'Your personal information',
		email: 'EMAIL',
		newEmail: 'NEW EMAIL',
		emailConfirm: 'EMAIL CONFIRMATION',
		previousPassword: 'OLD PASSWORD',
		newPassword: 'NEW PASSWORD',
		password: 'PASSWORD',
		phone: 'MOBILE PHONE',
		modify: 'Edit',
		modifyEmail: 'Edit your email',
		modifyPassword: 'Change your password',
		modifyPhone: 'Change your phone number',
		payments: 'Your payment methods',
		paymentDesc: 'To simplify your payments, YouFirst offers you to subscribe to direct debit for your contracts.',
		paymentBtn: 'Subscribe to direct debit',
		subscriptionPaymentInProgress: 'Your request to switch to direct debit is pending confirmation by your manager.',
		paymentLabel: 'LEASE N°{numero}, LOT(S) {lot} - {address}',
		preferences: 'Your preferences',
		eReleveDesc: 'An email notification will be sent to you each time a document is uploaded',
		eReleve: 'E-STATEMENT SUBSCRIPTION',
		language: 'You prefer to communicate with us via:',
		youfirstInformations: {
			titleCampus: 'YouFirst Campus news',
			titleResi: 'YouFirst news',
			info: 'The news of your residence relates to life in the building and our relationship. An email notification will be sent to you each time a new update is published in your Customer Area.',
			secondInfo: 'If you uncheck email and/or SMS notifications, you will still receive information related to lease life: water outage, elevator breakdown, etc.',
			email: {
				label: 'EMAIL'
			},
			sms: {
				label: 'SMS'
			},
			infoTitleCampus: 'YouFirst Campus information',
			infoTitleResi: 'YouFirst Residence information',
			infoMessage: 'You will receive information about your future residence.'
		},
		followEmail: {
			label: 'Tracking of my email opens',
			text: 'My personal data will be used and shared in accordance with the Privacy Policy, and YouFirst uses tracking pixels to measure my interactions with the communications sent to me and to improve their relevance.',
			lienGecina: 'Gecina Privacy Policy',
			lienYoufirst: 'YouFirst Privacy Policy',
			accept: 'I accept',
			refuse: 'I refuse'
		},
		errors: {
			default_error: 'An error occurred while updating the user',
			crm_edit_phone: 'An error occurred while updating the phone number',
			crm_edit_email: 'An error occurred while updating the email',
			okta_edit_email: 'An error occurred while updating the email',
			okta_default_error: 'An error occurred while retrieving the user',
			okta_user_not_found: 'The user wasn\'t found',
			okta_missing_requirements: 'An error occurred while updating the password: the password must contain 8 characters including at least one uppercase letter, one digit, and one lowercase letter',
			okta_recent_password: 'An error occurred while updating the password: the password was used recently',
			okta_old_password: 'An error occurred while updating the password: the old password is incorrect',
			okta_edit_password: 'An error occurred while updating the user password',
			missing_old_email: 'An error occurred: the old email is missing',
			preferences: 'An error occurred while updating the preferences',
			get_user_data: 'An error occurred while retrieving user data'
		},
		success: 'Changes saved',
		prelevement: {
			button: 'Switch to direct debit',
			title: 'Subscribe to direct debit',
			subtitle: 'Could you complete your information?',
			subHeader: {
				bail: '{nbContracts, plural, one {Lease} other {Leases}} no. {bail}'
			},
			step0: {
				title: 'Contracts for which you wish to subscribe to direct debit'
			},
			step1: {
				title: 'Complete the debtor\'s personal information',
				firstname: 'First name',
				lastname: 'Last name',
				street: 'Street and number',
				postalCode: 'Postal code',
				city: 'City',
				country: 'Country',
				email: 'Email',
				phone: 'Phone',
				sms: 'An SMS will be sent to you during the electronic signature of the document',
				errorPhone: 'An error occurred, please check your phone number',
				internalError: 'An error occurred, please try again later',
				generationMandatError: 'Unable to generate the direct debit mandate'
			},
			step2: {
				title: 'Fill in your banking information:',
				iban: 'IBAN code',
				bic: 'BIC code',
				rib: 'Add your RIB'
			},
			step3: {
				iframeTitle: 'Direct debit mandate signature',
				title: 'Your request has been successfully recorded.',
				subTitle: 'We will get back to you as soon as possible regarding your subscription to direct debit'
			}
		}
	},
	services: {
		title: 'Services',
		link: 'All services',
		emptyState: 'Services will soon be available in your residence, stay tuned!',
		details: {
			seeAllServices: 'View all services',
			error: 'The requested service wasn\'t found',
			title: 'Other YouFirst services'
		},
		modal: {
			form: {
				title: 'The service "{title}" interests you',
				subtitle: 'Do you have any specific questions?',
				submit: 'Send'
			},
			summary: {
				title: 'Your request has been successfully recorded.',
				text: 'We will get back to you shortly regarding the service that caught your interest.'
			}
		}
	},
	popinCGU: {
		title: 'Terms and Conditions of Use'
	},
	popinEcDesactive: {
		title: 'Customer Area deactivated',
		text: 'Dear Sir/Madam, {br} Access to the Customer Area is unavailable. {br} Please contact support for assistance'
	},
	enums: {
		paymentsMode: {
			CHQ: 'Check',
			PRLAUTO: 'Direct debit',
			TIP: 'TIP',
			LCH: 'LCH',
			VIRAUTO: 'Automatic transfer',
			VIRM: 'Transfer'
		},
		languages: {
			fr: 'French',
			en: 'English'
		}
	},
	global: {
		back: 'Back',
		fields: {
			select: {
				default: 'Choose'
			}
		},
		errors: {
			required: 'Required*',
			formatEmail: 'Incorrect email format',
			notSameEmail: 'The entered email and its confirmation do not match',
			formatPassword: 'The password must contain at least 8 characters including at least one digit, one lowercase letter, and one uppercase letter',
			formatPhone: 'The phone number must not exceed 20 characters',
			sameDateChoice: 'Date and time slot already chosen',
			fileSize: 'File upload failed because the file exceeds 30MB',
			authorizedExt: 'Allowed files: .png, .jpg, .jpeg, .gif, .pdf',
			sameCreneau: 'You can\'t choose the same time slot twice'
		},
		btn: {
			save: 'Save',
			cancel: 'Cancel',
			accept: 'Accept',
			refuse: 'Decline',
			next: 'Next',
			validate: 'Validate',
			finish: 'Finish',
			continue: 'Send your request'
		},
		switch: {
			enabled: 'Activated',
			disabled: 'Deactivated'
		}
	},
	footer: {
		details: {
			error: 'The requested page wasn\'t found'
		}
	},
	cookie: {
		title: 'Cookie management',
		text: 'This site uses Google Analytics. By accepting, you allow us to place cookies for audience measurement purposes. {br} For more information, see our {page} page',
		link: 'Cookie management policy'
	},
	changementAppartement: {
		enCours: {
			titre: {
				ajoutAppartement: 'Your apartment rental request',
				changementAppartement: 'Your apartment change request',
				ajoutParking: 'Your parking rental request',
				changementParking: 'Your parking change request'
			},
			bouton: 'View your request'
		},
		titre: 'Do you want to change your rental or add another one?',
		sousTitre: 'Tell us more about your need',
		changerAppartement: 'Change apartment',
		ajouterAppartement: 'Add an apartment',
		changerParking: 'Change parking',
		ajouterParking: 'Add a parking',
		formulaire: {
			titre: 'Your new need',
			choixResidence: {
				label: 'Do you wish to stay in the same residence?'
			},
			ville: {
				label: 'Desired cities and districts',
				placeholder: 'Choose from the list',
				paris: 'Paris (75)',
				paris1: '75001 Paris',
				paris2: '75002 Paris',
				paris3: '75003 Paris',
				paris8: '75008 Paris',
				paris9: '75009 Paris',
				paris11: '75011 Paris',
				paris12: '75012 Paris',
				paris13: '75013 Paris',
				paris15: '75015 Paris',
				paris16: '75016 Paris',
				paris17: '75017 Paris',
				paris20: '75020 Paris',
				boulogne: '92100 Boulogne-Billancourt',
				courbevoie: '92400 Courbevoie',
				avray: '92410 Ville-d\'Avray'
			},
			nombrePieces: {
				label: 'Number of rooms'
			},
			nombreChambres: {
				label: 'Number of bedrooms'
			},
			espaceExterieur: {
				label: 'Outdoor space'
			},
			budgetMaximum: {
				label: 'Maximum budget',
				tooltip: 'Your income must be at least 3 times the rent including charges'
			},
			dateArrivee: {
				label: 'Desired move-in date',
				tooltip: 'We will confirm your move-in date once your file is approved'
			},
			commentaire: {
				label: 'Comment'
			},
			raisonRecherche: {
				title: 'What is the reason for your search?',
				label: 'Answer',
				placeholder: 'Choose',
				sell: 'Sale of the property',
				deposit: 'Landlord notice',
				leave: 'Leaving parental home',
				uncomfortable: 'Lack of comfort',
				tooSmall: 'Apartment too small',
				tooLarge: 'Apartment too large',
				mutation: 'Transfer / Job relocation',
				rupture: 'Separation',
				closerToWork: 'Closer to workplace',
				primary: 'Secondary residence / pied-à-terre',
				rentToHigh: 'Rent too high',
				unsafe: 'Unsafe environment',
				other: 'Other'
			},
			profilLocataire: {
				titre: {
					appartement: 'Who will live in the apartment?',
					parking: 'Who will use the parking space?'
				},
				statut: {
					alone: 'You alone',
					couple: 'Two people',
					family: 'Your family',
					other: 'Other'
				},
				sousStatut: {
					alone: {
						appartement: 'You live alone, without children',
						parking: 'You will use the parking alone'
					},
					couple: {
						appartement: 'You occupy your apartment as a couple, without children',
						parking: 'You will use the parking as a couple'
					},
					family: {
						appartement: 'You are alone or a couple with at least one child',
						parking: ''
					},
					other: {
						appartement: 'You live in a shared apartment',
						parking: ''
					}
				}
			},
			familleMonoparental: {
				label: 'You are a single-parent family (one adult signing the lease)'
			},
			nbColoc: {
				label: 'Number of roommates (including you)'
			},
			promoCode: {
				placeholder: 'Privilege code',
				description: 'The privilege code will be taken into account when validating your file'
			},
			selectionCopreneur: {
				label: {
					appartement: 'Who will join you in the future apartment?',
					parking: 'Who will share the parking space with you?'
				}
			},
			typeVehicule: {
				label: 'For what type of vehicle?'
			},
			dimensionVehicule: {
				title: 'Vehicle dimensions'
			},
			longueur: {
				label: 'Length in mm'
			},
			largeur: {
				label: 'Width in mm'
			},
			hauteur: {
				label: 'Height in mm'
			},
			isStudent: {
				label: 'Are you a student?',
				subTitle: 'If "Yes" and <span>{mainInformation}</span>, it will be necessary to identify a guarantor to reserve the chosen property.',
				mainInformation: 'without a scholarship',

			},
			isBoursier: {
				label: 'Do you have a scholarship?',
			}
		}
	},
	preparezArrivee: {
		titre: 'Prepare your arrival',
		pdl: {
			titre: 'Energy delivery point (PDL)',
			texte: 'Provide N°{numeroPDL} to your energy providers to open your account.'
		},
		prelAuto: {
			titre: 'Direct debit',
			texte: 'Adopt it and simplify your rental management.',
			lien: 'Subscribe'
		},
		assurance: {
			titre: 'Share your insurance certificate',
			texte: 'Remember to provide us with your insurance certificate no later than the first day of your rental, at the move-in inspection.'
		},
		etatLieuxRemiseCles: {
			titre: 'Entry inventory and key collection',
			texteRdvNonPlanifie: 'Your YouFirst Manager will carry out the ckeck-in inventory with you before the keys are handed over. Please remember to book an appointment.',
			texteRdvPlanifie: 'Your appointment has been scheduled.',
			texteRdvPlanifieCreneaux: 'Your availability time slots have been shared with your YouFirst Manager. They will get back to you shortly to schedule the appointment.',
			ctaRdvNonPlanifie: 'Schedule my check-in inventory',
			ctaRdvPlanifie: 'Edit my appointment',
			erreurChargementOffre: 'Your property details could not be loaded. Please try again later or contact your YouFirst Manager.',
		},
		finAssurance: {
			titre: 'Share your insurance certificate',
			texte: 'Please provide us with your insurance certificate. It is mandatory for move-in',
			lien: 'Submit'
		},
		modalPriseRdvEdle: {
			titre: 'Chose your appointment date',
			bouton: 'Confirm your appointment',
			aucuneDispo: 'No available time slot works for you ?',
			aucuneDispoTexte: 'Please select 3 time slots below. Your YouFirst Manager will contact you to arrange a date and time according to your preferences',
			choix1: 'Choice 1 *',
			choix2: 'Choice 2',
			choix3: 'Choice 3',
			placeholders: {
				jour: 'Day',
				creneau: 'Hours'
			},
			enums: {
				creneaux: {
					MATIN1: '8h-10h',
					MATIN2: '10h-12h',
					APREM1: '14h-16h',
					APREM2: '16h-18h',
				},
				jours: {
					LUNDI: 'Monday',
					MARDI: 'Tuesday',
					MERCREDI: 'Wednesday',
					JEUDI: 'Thursday',
					VENDREDI: 'Friday'
				}
			},
			edleValide: 'Your check-in inventory appointment is confirmed',
			edlsValide: 'Your check-out inventory appointment is confirmed',
		},
	},
	preparezDepart: {
		titre: 'Prepare your departure',
		etatLieuxRemiseCles: {
			titre: 'Move-out inspection and key handover',
			texteRdvNonPlanifie: 'Your YouFirst Manager will carry out the ckeck-in inventory with you before the keys are handed over. Please remember to book an appointment',
			texteRdvPlanifie: 'Your appointment has been scheduled.',
			texteRdvPlanifieCreneaux: 'Your availability time slots have been shared with your YouFirst Manager. They will get back to you shortly to schedule the appointment.',
			ctaRdvNonPlanifie: 'Schedule my check-out inventory',
			ctaRdvPlanifie: 'Edit my appointment',
		}
	}
}

export default flatten<typeof target, ModelTranslations>(target)